import Vue from "vue";
import VeeValidate from "vee-validate";

import messageFr from "../locale/fr";

Vue.use(VeeValidate, {
  locale: "fr",
  events: "blur",
  classes: true,
  dictionary: {
    fr: messageFr
  }
});
